import React from 'react';
import { IconLinhas, IconInfo, IconNearby } from '../ui/icons';

function FloatingNav({ activeTab, onTabChange, onNearbyStopsClick, nearbyStopsLoading = false, nearbyStopsActive = false }) {
  const tabs = [
    { id: 'linhas', label: 'Linhas', icon: <IconLinhas aria-hidden="true" /> },
    { id: 'info', label: 'Info', icon: <IconInfo aria-hidden="true" /> }
  ];

  return (
    <div className="floating-nav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`floating-nav-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
          aria-label={tab.label}
          title={tab.label}
        >
          <span className="floating-nav-icon">{tab.icon}</span>
          <span className="floating-nav-label">{tab.label}</span>
        </button>
      ))}

      <button
        className={`floating-nav-btn ${nearbyStopsActive ? 'active' : ''}`}
        onClick={onNearbyStopsClick}
        aria-label="Paradas perto de mim"
        title={nearbyStopsLoading ? 'Buscando paradas...' : 'Paradas perto de mim'}
        disabled={nearbyStopsLoading}
      >
        <span className="floating-nav-icon"><IconNearby aria-hidden="true" /></span>
        <span className="floating-nav-label">Perto</span>
      </button>
    </div>
  );
}

export default FloatingNav;
